export function formKeyGenerator(src, formType, formFormat) {
  return `${src ?? 'digiroom'}_${formType}_${formFormat}`;
}
